import * as React from "react";
import { Container, ContainerFW } from "../../global";
import { ImgV2 } from "../../ImgV2/ImgV2";
import { getColors } from "../../../utils/getColors";
import { Heading } from "../../Heading";
import { TTAccBannerButtonAndLink } from "./TTAccBannerButtonAndLink";
export const ThinkTraderAccountBanner = ({ title, description, imageUrl, imageAlt, list, buttonLink, buttonText, openInNewTab, backgroundColor, linkButtonLabel, linkButtonUrl, disclaimer, }) => {
    const { bgColor } = getColors(backgroundColor);
    const standardString = React.useCallback((value) => {
        if (value.includes("<br />")) {
            return value.replace("<br />", "<span class=\"special-symbol\">  |  </span>");
        }
        return value;
    }, []);
    const checkHasButtons = () => buttonLink || (linkButtonLabel && linkButtonUrl);
    const showButtonWrapper = checkHasButtons();
    return (React.createElement(ContainerFW, { backgroundColor: bgColor },
        React.createElement(Container, null,
            React.createElement("div", { className: "thinktrader-account-banner" },
                React.createElement("div", { className: "thinktrader-account-banner__text-wrapper" },
                    React.createElement("div", { className: "thinktrader-account-banner__h1-h5-wrapper" },
                        React.createElement(Heading, { design: "h1-regular" }, title),
                        React.createElement("h5", { className: "h5-semi-bold", dangerouslySetInnerHTML: {
                                __html: description,
                            } })),
                    list && list.length > 0 && (React.createElement("div", { className: "thinktrader-account-banner__options-wrapper" }, list.map((item, i) => (React.createElement("div", { key: i, className: "thinktrader-account-banner__option" },
                        React.createElement("p", { className: "thinktrader-account-banner__option__p-title" }, item.itemTitle),
                        React.createElement("div", { className: "thinktrader-account-banner__option__p-subtitle", dangerouslySetInnerHTML: {
                                __html: standardString(item.itemSubTitle) || "",
                            } })))))),
                    showButtonWrapper && (React.createElement(TTAccBannerButtonAndLink, { buttonLink: buttonLink, buttonText: buttonText, linkButtonUrl: linkButtonUrl, linkButtonLabel: linkButtonLabel, openInNewTab: openInNewTab })),
                    disclaimer && (React.createElement("div", { className: "thinktrader-account-banner__disclaimer", dangerouslySetInnerHTML: {
                            __html: disclaimer || "",
                        } }))),
                React.createElement("div", { className: "thinktrader-account-banner__image-wrapper" },
                    React.createElement(ImgV2, { src: imageUrl, alt: imageAlt, loading: "eager" }))))));
};
